import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import "./Pages.scss";
import _times from 'lodash/times';
import PageNumber from './PageNumber';
import PreviousPage from './PreviousPage';
import NextPage from './NextPage';

const PagesControl = (props) => {
    const limit = 10
    const [minVisible, setMinVisible] = useState(0);
    const [maxVisible, setMaxVisible] = useState(0);

    useEffect(() => {
        var start = Math.max(0, props.currentPage - limit)
        var end = Math.min(props.maxPage + 1, props.currentPage + 10)

        if (start !== 0 && end - start < 2 * limit) {
            start = Math.max(0, end - 2 * limit);
        } else if (end !== props.maxPage + 1 && end - start < 2 * limit) {
            end = Math.min(props.maxPage + 1, start + 2 * limit)
        }

        if (start !== minVisible) {
            setMinVisible(start)
        }
        if (end !== maxVisible) {
            setMaxVisible(end);
        }
    }, [props.maxPage, props.currentPage])

    return (
        <div className='pages'>
            <PreviousPage {...props} />
            {_times((maxVisible - minVisible), (i) => (
                <PageNumber {...props} pageNumber={i + minVisible} key={`pn_${i}`} />
            ))}
            <NextPage {...props} />
        </div>
    )
}

PagesControl.propTypes = {
    currentPage: PropTypes.number.isRequired,
    maxPage: PropTypes.number.isRequired,
    onSetPage: PropTypes.func.isRequired
}

export default PagesControl;